import React from 'react';
import ButtonBase from './ButtonBase';
import { TButtonsDefault } from './types/TButtons';

const DestructiveGhost = ({ as = 'button', ...rest }: TButtonsDefault) => (
  <ButtonBase {...rest} as={as} kind="destructive-ghost" />
);

export default DestructiveGhost;
